import { Pressable, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { falExpand } from 'shared/@generated/icons/falExpand';
import { Icon } from 'shared/components/icon';
import { Image, type ImageProps } from 'shared/components/image';

type GalleryImageProps = ImageProps & {
  onPress?: () => void;
  testID?: string;
};

export function GalleryImage({
  onPress,
  testID,
  containerClassName,
  alt,
  ...imageProps
}: GalleryImageProps) {
  const { t } = useTranslation('common');

  if (!onPress || !imageProps.src) {
    return <Image {...imageProps} alt={alt} containerClassName={containerClassName} />;
  }

  return (
    <Pressable
      accessibilityRole={'button'}
      accessibilityLabel={alt ? `${t('expand')}: ${alt}` : t('expand')}
      className={`focus-visible:ring-brand-green relative cursor-zoom-in focus:outline-none focus-visible:ring-2 ${containerClassName}`}
      onPress={onPress}
      testID={testID}
    >
      <Image {...imageProps} alt={alt} containerClassName={'size-full'} />
      <View pointerEvents={'none'} className={'absolute bottom-1 right-1 rounded bg-black/20 p-1'}>
        <Icon icon={falExpand} className={'size-3.5 text-white'} />
      </View>
    </Pressable>
  );
}
